import ChemicalWaste from '../components/ChemicalWaste';

function ChemicalWastePage() {
  return <ChemicalWaste />;
}

export default ChemicalWastePage;
